import { useQuery } from '@tanstack/react-query';

import { fetchNightlyVariables } from 'apis/hcp/reports.api';
import { NightlyResponse } from 'types/hcp/pdfreport.type';

const transformResponse = (response: { data: { nightly: NightlyResponse } }) => {
  return response.data.nightly;
};

const useGetNightlyData = (id: string, oldTest?: boolean) => {
  const {
    data: nightly,
    isPending: nightlyLoading,
    error,
  } = useQuery({
    queryKey: ['reports', 'nightly', 'variables', id],
    queryFn: ({ signal }) => fetchNightlyVariables(id, signal),
    select: transformResponse,
    enabled: !!id,
    retry: 1,
    retryOnMount: !oldTest,
  });

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const nightlyError: any = error;
  return { nightly, nightlyLoading, nightlyError };
};

export default useGetNightlyData;
